export default function MarkdownService() {
  function markdownToUrl(hyperlink) {
    var regex = /\[([^\]]+)\]\(([^)]+)\)/;
    var arr = regex.exec(hyperlink);
    const [, text, url] = arr || [];
    return {
      url: url || hyperlink,
      text: text || hyperlink
    };
  }

  function urlToMarkdown(hyperlink) {
    return `[${hyperlink.text}](${hyperlink.url})`;
  }

  return {
    markdownToUrl: markdownToUrl,
    urlToMarkdown: urlToMarkdown
  };
}
